<template>
  <div class="wrapper">
    <template v-for="item in childrens">
      <template v-if="item.auth !== false">
        <el-submenu :index="item.key" v-if="item.children" :key="item.key" class="multiple-menu">
          <template slot="title">
            <i :class="item.icon"></i>
            <span>{{ item.name }}</span>
          </template>
          <children-menu :children="item.children"></children-menu>
        </el-submenu>
        <el-menu-item :index="item.key" :key="item.key" v-else>
          <i :class="item.icon"></i><span>{{ item.name }}</span>
        </el-menu-item>
      </template>
    </template>
  </div>
</template>
<script>
export default {
  // 让组件能够调用自身需要声明name属性
  name: "ChildrenMenu",
  props: {
    children: {
      type: Array
    }
  },
  computed: {
    childrens() {
      const childrens = JSON.parse(JSON.stringify(this.children));

      childrens.forEach(item => {
        if (item.icon && item.icon.indexOf("el-icon-cls") !== -1) {
          item.icon = `iconfont ${item.icon}`;
        } else if (item.icon && item.icon.indexOf("el-icon-cls") === -1) {
          item.icon = `elementiconfont ${item.icon}`;
        } else {
          item.icon = "iconfont";
        }
      });
      return childrens;
    }
  }
};
</script>
